<template>
  <el-col class="displayLayout" id="orderManagement">
    <template>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="订单状态">
          <el-select v-model="formInline.orderStatus" placeholder="全部">
            <el-option label="全部" value=""></el-option>
            <el-option label="保存待提交" value="0"></el-option>
            <el-option label="审核中" value="1"></el-option>
            <el-option label="审核成功" value="2"></el-option>
            <el-option label="审核成功待支付" value="3"></el-option>
            <el-option label="审核失败" value="4"></el-option>
            <el-option label="支付成功" value="5"></el-option>
            <el-option label="支付失败" value="6"></el-option>
            <el-option label="已过期取消" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号">
          <el-input v-model="formInline.orderIdNum" placeholder="订单号"></el-input>
        </el-form-item>
        <el-form-item label="企业名称">
          <el-input v-model="formInline.policyHolderName" placeholder="企业名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSelect">查询</el-button>
        </el-form-item>
      </el-form>
    </template>
    <template>
      <el-table
        :data="tableData"
        style="width: 100%;"
        v-loading="loading">
        <el-table-column prop="id"
                         width="210"
                         label="订单号">
        </el-table-column>
        <el-table-column prop="orderStatus"
                         label="订单状态">
          <template slot-scope="scope">
            <div v-if="scope.row.orderStatus === 0">保存待提交</div>
            <div v-if="scope.row.orderStatus === 1">审核中</div>
            <div v-if="scope.row.orderStatus === 2">审核成功</div>
            <div v-if="scope.row.orderStatus === 3">审核成功待支付</div>
            <div v-if="scope.row.orderStatus === 4">审核失败</div>
            <div v-if="scope.row.orderStatus === 5">支付成功</div>
            <div v-if="scope.row.orderStatus === 6">支付失败</div>
            <div v-if="scope.row.orderStatus === 7">已过期取消</div>
          </template>
        </el-table-column>
        <el-table-column prop="productName"
                         label="产品名称">
        </el-table-column>
        <el-table-column prop="policyHolderName"
                         min-width="150"
                         label="企业名称">
        </el-table-column>
        <el-table-column prop="createTime"
                         width="100"
                         label="创建时间">
        </el-table-column>
        <el-table-column prop="issueDate"
                         width="100"
                         label="出单时间">
        </el-table-column>
        <el-table-column label="投保操作">
          <template slot-scope="scope">
            <!--            href="${proposalUrl}" ${$$.isValidObj(proposalUrlSuffix) ? `download="${proposalUrlSuffix}" target="_blank"` : `onclick='$$.alert("电子投保单链接生成中~");'` }-->
            <el-button size="mini" @click="$message.success('当前订单保费：'+ scope.row.payMoney + '元')"
                       v-if="scope.row.orderStatus === 2 || scope.row.orderStatus === 3">查看保费
            </el-button>
            <a :href="scope.row.proposalUrl"
               :download="$$.isValidObj(scope.row.proposalUrlSuffix) ? scope.row.proposalUrlSuffix : ''"
               :target="$$.isValidObj(scope.row.proposalUrlSuffix) ? '_blank' : ''"
               @click="$$.isValidObj(scope.row.proposalUrlSuffix) ? '' : $message.info('电子投保单链接生成中~')"
            >
              <el-button size="mini" style="width: 80px"  v-if="scope.row.orderStatus === 2 || scope.row.orderStatus === 3 || scope.row.orderStatus === 5">下载投保单</el-button>
            </a>
            <a :href="scope.row.payNoticeUrl"
               :download="$$.isValidObj(scope.row.payNoticeUrlSuffix) ? scope.row.payNoticeUrlSuffix : ''"
               :target="$$.isValidObj(scope.row.payNoticeUrlSuffix) ? '_blank' : ''"
               @click="$$.isValidObj(scope.row.payNoticeUrlSuffix) ? '' : $message.info('收费通知书链接生成中~')"
            >
              <el-button size="mini" style="width: 80px"  v-if="scope.row.orderStatus === 2 || scope.row.orderStatus === 3">下载投保单</el-button>
            </a>
            <span v-if="scope.row.orderStatus === 2">
              <el-button size="mini" >上传已盖章的投保单</el-button>
            </span>
            <el-button size="mini" v-if="scope.row.orderStatus === 3">支付</el-button>
          </template>
        </el-table-column>
        <el-table-column label="其他操作">
          <template slot-scope="scope">
            <el-button size="mini" @click="edit(scope.row)" v-if="scope.row.orderStatus === 0">编辑</el-button>
            <el-button size="mini" @click="onSubmit(scope.row)" v-if="scope.row.orderStatus === 0">提交</el-button>
            <el-button size="mini" @click="onSee(scope.row)">查看详情</el-button>
            <el-button size="mini" @click="onPay(scope.row)" v-if="scope.row.orderStatus === 4">错误消息</el-button>
            <el-button size="mini" @click="onDelete(scope.row)"
                       v-if=" scope.row.orderStatus === 0 || scope.row.orderStatus === 7 ">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div class="block">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="getOrderList"
        :current-page.sync="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </el-col>
</template>

<script>
  import $$ from "../../../tool/BaseXJT";

  export default {
    name: "orderManagement",
    data() {
      return {
        token: "",
        loading: false,
        page: 1,
        total: 0,
        pageSize: 10,
        tableData: [],
        formInline: {
          orderIdNum: '',
          orderStatus: '',
          policyHolderName: '',
        }
      }
    },
    methods: {
      /**
       * 编辑
       * @param row
       */
      edit(row) {
        this.$router.push({path: '/haoLian/fillInfo', query: {id: row.id, token: this.token}});
      },
      /**
       * 查看
       * @param row
       */
      onSee(row) {
        this.$router.push({path: '/haoLian/orderDetails', query: {id: row.id, returnPageType: '1', token: this.token}});
      },
      /**
       * 立刻支付
       * @param row
       */
      onPay(row) {
        let loadingInstance = this.Loading.service({fullscreen: true});
        let shareToken = this.$$.isValidObj(row.shareToken) ? row.shareToken : '';

        this.axios.post('/management/mobileInsuranceInfo/orderPaymentBefore?orderToken=' + encodeURIComponent(decodeURIComponent(row.orderToken)) + '&beShareToken=' + encodeURIComponent(decodeURIComponent(shareToken))).then((response) => {
          let data = response.data;
          if (data.success == true) {
            let params = {
              orderToken: data.datas.orderToken,
              sellProductName: row.productName
            };
            sessionStorage.setItem('orderPaymentParams', JSON.stringify(params));
            this.$router.push({name: 'orderPaymentType'});
          } else {
            let msg = this.$$.constant.error_codes[data.msg];
            this.$message({
              type: 'info',
              message: this.$$.isValidObj(msg) ? msg : data.msg
            });
          }
          this.$nextTick(() => { // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
        });
      },
      onDelete(row) {
        this.$confirm('是否删除此订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post('/management/tariffInsurance/del', null, {
            params: {
              id: row.id
            }
          }).then((response) => {
            if (response.data.success == true) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.onSelect();
            } else {
              this.$message({
                type: 'info',
                message: response.data.msg
              });
            }
          });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      onSubmit(row) {

        let date = this.$$.getTimeStamp(new Date(row.effectiveDate)),
          now = new Date(this.$$.dateFormat(new Date()) + ' 00:00:00'),
          tomorrow = this.$$.getTimeStamp(new Date(now.setDate(now.getDate() + 3)));

        if (date < tomorrow) return this.$message.error("订单起保时间不能小于3天，请点击编辑修改订单起保时间~");
        this.loading = true;
        this.$confirm('确认提交订单?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.axios.post('/management/tariffInsurance/orderSubmissionReview', null, {
            params: {
              id: row.id
            }
          }).then((response) => {
            if (response.data.success == true) {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '提交成功!'
              });
              this.getOrderList();
            } else {
              this.$message({
                type: 'info',
                message: response.data.msg
              });
            }
          });
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
      },
      handleSizeChange(val) {
        this.page = 1;
        this.pageSize = val;
        this.getOrderList();
      },
      onSelect() {
        this.page = 1;
        this.getOrderList();
      },
      getOrderList() {
        this.loading = true;
        this.axios.post('/management/tariffInsurance/customsGuaranteeList', null, {
          params: {
            _pageSize: this.pageSize,
            _current: this.page,
            orderStatus: this.formInline.orderStatus,
            orderIdNum: this.formInline.orderIdNum,
            policyHolderName: this.formInline.policyHolderName
          }
        }).then((response) => {
          let data = response.data;
          if (data.success) {
            let {list, pagination} = data.datas;
            this.tableData = list;
            this.page = pagination.current;
            this.total = pagination.total;
            this.loading = false;

            list.forEach(item => {
              let {proposalUrl, payNoticeUrl} = item;
              this.$$.isValidObj(proposalUrl) ? item.proposalUrlSuffix = '投保单.' + proposalUrl.substr((~-proposalUrl.lastIndexOf(".") >>> 0) + 2) : item.proposalUrl = "javascript:;";
              this.$$.isValidObj(payNoticeUrl) ? item.payNoticeUrlSuffix = '收费通知书.' + payNoticeUrl.substr((~-payNoticeUrl.lastIndexOf(".") >>> 0) + 2) : item.payNoticeUrl = "javascript:;";
            });

          } else {
            this.$message.error(data.msg);
          }

          let height = $('.contentModule').outerHeight() - ($('.demo-form-inline').outerHeight() + $('.el-table thead').height() + $('.el-pagination').outerHeight());
          $('.el-table__body-wrapper').css('height', height);
        })
      }
    },
    mounted() {
      $('.wrapper>footer').hide();
      let mainHeight = $('html').height() - $('header').height();
      $('.wrapper>main').css('min-height', mainHeight);

      //-- token
      let token = this.$route.query.token,
        value = this.$$.localStorageGet('MYRCIB_THIRD_PARTY_TOKEN');
      if ($$.isValidObj(token)){
        if (!$$.isValidObj(value) || value != token) this.$$.localStorageSet('MYRCIB_THIRD_PARTY_TOKEN', token);
        this.axios.defaults.headers.common['MYRCIB_THIRD_PARTY_TOKEN'] = token;
        this.token = token;
      }

      this.getOrderList();
    }
  }
</script>

<style scoped>
  @import "../../../../static/css/orderManagement.css";

  .contentModule{
    position: relative;
  }

  .displayLayout{
    width: 100%;
    padding: 0 5%;
    position: initial;
  }
</style>



// WEBPACK FOOTER //
// src/components/product/haoLian/orderManagement.vue